module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Heavy.3e0167a9.ttf";